export const UNITS = {
  MILLIMETER: "mm",
  INCH: "in",
  CELSIUS: "°C",
  FAHRENHEIT: "°F",
};
